import { createFileRoute, redirect } from '@tanstack/react-router';
import type { StyleDetail, VariantDetail } from '@/api/my-styles/types';
import { StyleHierarchySkusTab } from '@/app/(client)/my-styles/-components/StyleHierarchySkusTab';
import {
  isEntityKindPath,
  styleDetailQueryOptions,
  useEntityDetail,
  variantDetailQueryOptions,
} from '@/app/(client)/my-styles/-hooks/useEntityDetail';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/my-components/(pages)/(detail)/$kind/$id/skus',
)({
  beforeLoad: ({ params }) => {
    if (!isEntityKindPath(params.kind) || params.kind === 'skus') {
      throw redirect({
        to: '/my-components/$kind/$id',
        params: {
          kind: isEntityKindPath(params.kind) ? params.kind : 'styles',
          id: params.id,
        },
      });
    }
  },
  loader: ({ params }) => {
    if (params.kind === 'styles') {
      return queryClient.ensureQueryData(styleDetailQueryOptions(params.id));
    }
    if (params.kind === 'variants') {
      return queryClient.ensureQueryData(variantDetailQueryOptions(params.id));
    }
  },
  component: SkusSubtabRoute,
});

function SkusSubtabRoute() {
  const { kind, id } = Route.useParams();
  const { data: entity } = useEntityDetail(
    isEntityKindPath(kind) ? kind : 'styles',
    id,
  );

  if (kind === 'styles') {
    const style = entity as StyleDetail | undefined;
    return (
      <StyleHierarchySkusTab
        parentKind='styles'
        parentId={id}
        parentName={style?.name ?? ''}
        styleIdForCreate={id}
      />
    );
  }

  const variant = entity as VariantDetail | undefined;
  return (
    <StyleHierarchySkusTab
      parentKind='variants'
      parentId={id}
      parentName={variant?.name ?? ''}
      styleIdForCreate={variant?.styleId ?? ''}
    />
  );
}
